import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TooltipComponent} from '../../../shared/elements/tooltip/tooltip.component';
import {DashboardLinkResource} from '../../../shared/types/generated/dashboardLinkResource';
import {TranslatePipe} from "../../../shared/pipes/translate.pipe";

@Component({
    selector: 'app-home-links',
    imports: [TooltipComponent, TranslatePipe],
    templateUrl: './custom-links.component.html',
    styleUrls: ['./custom-links.component.scss']
})
export class HomeLinksComponent {
  @Input({required: true}) public links: DashboardLinkResource[] = [];
  @Input() public page:number = 1;
  @Input() public variant: 'grid' | 'quick-nav' = 'grid';
  @Input() public showPagination: boolean = true;

  /** Max links per page – controlled by parent (depends on breakpoint) */
  @Input() public maxPerPage:number = 8;

  @Output() public pageChange:EventEmitter<number> = new EventEmitter<number>();
  @Output() public linkClick:EventEmitter<DashboardLinkResource> = new EventEmitter<DashboardLinkResource>();

  
  public get totalPages(): number {
    if (!this.links.length || !this.maxPerPage) return 0;
    return Math.ceil(this.links.length / this.maxPerPage);
  }

  public get pageNumbers(): number[] {
    if (!this.totalPages) return [];
    return Array.from({length: this.totalPages}, (_, i) => i + 1);
  }

  public get pagedLinks(): DashboardLinkResource[] {
    if (!this.links.length || !this.maxPerPage) return [];
    const start = (this.page - 1) * this.maxPerPage;
    const end = start + this.maxPerPage;
    return this.links.slice(start, end);
  }

  /** Placeholder tiles to keep the last row visually filled */
  public get placeholders(): number[] {
    if (!this.links.length || !this.maxPerPage) {
      return [];
    }

    const totalPages = Math.ceil(this.links.length / this.maxPerPage);

    // only add placeholders on the *last* page
    if (this.page !== totalPages) {
      return [];
    }

    const remainder = this.links.length % this.maxPerPage;
    const missing = this.maxPerPage - (remainder || this.maxPerPage);

    return Array.from({length: missing}, (_, index) => index);
  }

  public onPageClick(p: number): void {
    if (p < 1 || p > this.totalPages) return;
    this.pageChange.emit(p);
  }

  public onLinkClick(link: DashboardLinkResource): void {
    this.linkClick.emit(link);
  }

  public onLinkKeydown(event: KeyboardEvent, link: DashboardLinkResource): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.onLinkClick(link);
    }
  }

  public trackByIndex(index: number): number {
    return index;
  }
}
